import React, { PropsWithChildren } from 'react';
import { NumberCardLayout, NumberCardTextLayout } from '../NumberCard/NumberCard.style';
import { usecaseCardBanner } from '@assets/images/solution';
import { StyledDisplay, StyledHeading, StyledParagraph } from '@components/Text';
import { Trans } from 'react-i18next';
import { ImgWH, Spacing, SpacingDTM } from '@pages/CommonStyle/common.style';
import { CustomerLogoImg, SolutionCaseCard, SolutionCaseCardText } from './SolutionCase.style';
import { logoBlack } from '@assets/images/logo';
import { DivAllCenter, DivFlexColumn } from '@pages/CommonStyle/commonDiv.style';
import { StyledGridContainer } from '@components/Grid/Grid.style';

interface ModalDefaultType {
  path: any;
}

const SolutionCase: React.FC<PropsWithChildren<ModalDefaultType>> = ({ path }) => {
  const items = ['첫 번째', '두 번째', '세 번째']; // 👉 동적 배열 예시

  return (
    <>
      <NumberCardLayout img={usecaseCardBanner}>
        <StyledGridContainer>
          <DivAllCenter>
            <StyledDisplay size={'small'} color="#fff">
              <Trans i18nKey={path.customer.title} />
            </StyledDisplay>
            <SpacingDTM d="64" t="64" m="32" />

            <NumberCardTextLayout gap={32}>
              {path.customer.card.map((data, index) => (
                <React.Fragment key={index}>
                  <SolutionCaseCard>
                    <CustomerLogoImg w="75" h="75" src={data.logo} />
                    <SolutionCaseCardText>
                      <StyledParagraph size="large" color="#fff" style={{ wordBreak: 'break-word', textAlign: 'start' }}>
                        <Trans i18nKey={data.desc} />
                      </StyledParagraph>
                      <Spacing pixel="24" />
                      <StyledHeading size="xxxxsmall" color="#fff" style={{ wordBreak: 'break-word', textAlign: 'start' }}>
                        <Trans i18nKey={data.name} />
                      </StyledHeading>
                    </SolutionCaseCardText>
                  </SolutionCaseCard>
                </React.Fragment>
              ))}
            </NumberCardTextLayout>
          </DivAllCenter>
        </StyledGridContainer>
      </NumberCardLayout>
    </>
  );
};

export default SolutionCase;
